var RateCodeInformationView = Backbone.View.extend({
  events: {
    "click [data-rate-code-details-trigger]": "displayRateCodeDetails",
    "click [data-promo-details-trigger]": "displayPromoDetails",
    "click [data-rate-code-checkbox]": "processRateCodeSelection"
  },

  displayRateCodeDetails: function(event) {
    var url = $(event.currentTarget).data("rate-code-details-trigger");

    var Dialog = this.containers.rateCodeDetails
      .data("dialog-async", url)
      .component();

    Dialog.reflow().open();
  },

  displayPromoDetails: function(event) {
    var content = this.templates.promoDetails({
      versionId: $(event.currentTarget).data("promo-details-trigger")
    });

    var Dialog = this.containers.promoDetails.html(content).component();

    Dialog.reflow().open();
  },

  toggleSelectAll: function() {
    if (
      this.$("[data-rate-code-checkbox]").length ===
      this.$("[data-rate-code-checkbox]:checked").length
    ) {
      this.$("[data-select-all]").prop("checked", true);
    } else {
      this.$("[data-select-all]").prop("checked", false);
    }
  },

  limitSelections: function() {
    if (
      this.$("[data-rate-code-checkbox]:checked").length ===
      this.settings.maxSelections
    ) {
      this.$("[data-rate-code-checkbox]")
        .not(":checked")
        .prop("disabled", true);
    } else {
      this.$("[data-rate-code-checkbox]")
        .not(":checked")
        .prop("disabled", false);
    }
  },

  processRateCodeSelection: function() {
    if (
      !this.settings.isBookingModify ||
      (this.settings.isBookingModify && this.settings.allowRateCodeChange)
    ) {
      this.toggleSelectAll();
      this.limitSelections();
    }
  },

  initialize: function() {
    this.settings = this.$el.data("settings");

    this.containers = {
      rateCodeDetails: null,
      promoDetails: null
    };

    this.templates = {
      promoDetails: Handlebars.compile(
        this.$('[data-template="promo-details"]').html() || ""
      )
    };

    this.containers.rateCodeDetails = this.$("[data-rate-code-details-modal]");
    this.containers.promoDetails = this.$("[data-promo-details-modal]");

    if (
      !this.settings.isBookingModify ||
      (this.settings.isBookingModify && this.settings.allowRateCodeChange)
    ) {
      this.toggleSelectAll();
      this.limitSelections();
    }
  }
});

module.exports = RateCodeInformationView;
